export default __webpack_public_path__ + "static/media/640_dummy2016-personaltrainer01-mobile-de.d0576c57.png";